export const ROLES = {
    ADMIN: 'admin',
    EDITOR: 'editor',
    VIEWER: 'viewer',
};

export const PERMISSIONS = {
    // Case Processing
    CASE_CREATE: 'CASE_CREATE',
    CASE_UPDATE: 'CASE_UPDATE',
    CASE_DELETE: 'CASE_DELETE',

    // Coding
    MEDDRA_CODING: 'MEDDRA_CODING',
    WHODD_CODING: 'WHODD_CODING',

    // Administrative
    SECURITY_ADMIN: 'SECURITY_ADMIN',
    FULL_ADMIN: 'FULL_ADMIN',

    // Reporting
    GENERATE_REPORTS: 'GENERATE_REPORTS',
    SUBMIT_REPORTS: 'SUBMIT_REPORTS',
};

export const ROLE_PERMISSIONS = {
    [ROLES.ADMIN]: [
        PERMISSIONS.SECURITY_ADMIN,
        PERMISSIONS.FULL_ADMIN,
        PERMISSIONS.CASE_CREATE,
        PERMISSIONS.CASE_UPDATE,
        PERMISSIONS.CASE_DELETE
    ],
    [ROLES.EDITOR]: [
        PERMISSIONS.CASE_CREATE,
        PERMISSIONS.CASE_UPDATE
    ],
    [ROLES.VIEWER]: [], // View permissions handled by read-only flags usually, or specific view permissions
};

